import React from 'react';
import { styled } from '@mui/system';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';

const useStyles = styled((theme) => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
}));
export default function GE_curriculum_page() {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);
  const [showMore, setShowMore] = React.useState(false);
  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };
  const CustomExpandIcon = ({ isExpanded }) => (
    <span style={{ fontSize: "1.5rem", fontWeight: "bold" }}>
      {isExpanded ? "−" : "+"}
    </span>
  );
  return (
    <div className={classes.root} style={{ width: '85%', margin: '0 auto' }}>
      <Accordion
        className="py-2"
        expanded={expanded === "panel1"}
        onChange={handleChange("panel1")}
      >
        <AccordionSummary
          expandIcon={<CustomExpandIcon isExpanded={expanded === "panel1"} />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
        >
          <Typography style={{ fontSize: "1.2rem" }}>
           Introduction to Genetics
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            Learn the fundamentals of genetics, including Mendelian inheritance, genetic variation, and the molecular basis of heredity.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion
        className="py-2"
        expanded={expanded === "panel2"}
        onChange={handleChange("panel2")}
      >
        <AccordionSummary
          expandIcon={<CustomExpandIcon isExpanded={expanded === "panel2"} />}
          aria-controls="panel2bh-content"
          id="panel2bh-header"
        >
          <Typography style={{ fontSize: "1.2rem" }}>
            Cell Division & Inheritance Patterns
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            Understand mitosis, meiosis, ploidy, and X-linked inheritance to explore how traits are transmitted across generations.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion
        className="py-2"
        expanded={expanded === "panel3"}
        onChange={handleChange("panel3")}
      >
        <AccordionSummary
          expandIcon={<CustomExpandIcon isExpanded={expanded === "panel3"} />}
          aria-controls="panel3bh-content"
          id="panel3bh-header"
        >
          <Typography style={{ fontSize: "1.2rem" }}>
           Human Genome & Genetic Mapping
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            Study the Human Genome Project, gene sequencing, and how genome data is used to identify and analyze genetic traits.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion
        className="py-2"
        expanded={expanded === "panel4"}
        onChange={handleChange("panel4")}
      >
        <AccordionSummary
          expandIcon={<CustomExpandIcon isExpanded={expanded === "panel4"} />}
          aria-controls="panel4bh-content"
          id="panel4bh-header"
        >
          <Typography style={{ fontSize: "1.2rem" }}>
            Recombinant DNA Technology
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            Explore the principles of recombinant DNA, restriction enzymes, ligation, and cloning strategies that form the foundation of genetic engineering.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion
        className="py-2"
        expanded={expanded === "panel5"}
        onChange={handleChange("panel5")}
      >
        <AccordionSummary
          expandIcon={<CustomExpandIcon isExpanded={expanded === "panel5"} />}
          aria-controls="panel5bh-content"
          id="panel5bh-header"
        >
          <Typography style={{ fontSize: "1.2rem" }}>
            DNA Amplification & Analysis
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            Learn techniques like PCR (Polymerase Chain Reaction) and nucleic acid amplification for studying and replicating genetic material.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion
        className="py-2"
        expanded={expanded === "panel6"}
        onChange={handleChange("panel6")}
      >
        <AccordionSummary
          expandIcon={<CustomExpandIcon isExpanded={expanded === "panel6"} />}
          aria-controls="panel6bh-content"
          id="panel6bh-header"
        >
          <Typography style={{ fontSize: "1.2rem" }}>
           Gene Cloning & Vectors
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
           Understand the use of cloning vectors, plasmids, and DNA libraries in gene isolation, replication, and manipulation.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion
        className="py-2"
        expanded={expanded === "panel7"}
        onChange={handleChange("panel7")}
      >
        <AccordionSummary
          expandIcon={<CustomExpandIcon isExpanded={expanded === "panel7"} />}
          aria-controls="panel7bh-content"
          id="panel7bh-header"
        >
          <Typography style={{ fontSize: "1.2rem" }}>
            Site-Directed Mutagenesis & Gene Expression
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
           Study how specific gene modifications are introduced and how gene expression is measured using techniques like Northern blotting and microarrays.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion
        className="py-2"
        expanded={expanded === "panel8"}
        onChange={handleChange("panel8")}
      >
        <AccordionSummary
          expandIcon={<CustomExpandIcon isExpanded={expanded === "panel8"} />}
          aria-controls="panel8bh-content"
          id="panel8bh-header"
        >
          <Typography style={{ fontSize: "1.2rem" }}>
            Protein Interaction & Functional Genomics
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            Explore yeast two-hybrid systems, protein–protein interactions, and how genes influence cellular functions.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion
        className="py-2"
        expanded={expanded === "panel9"}
        onChange={handleChange("panel9")}
      >
        <AccordionSummary
          expandIcon={<CustomExpandIcon isExpanded={expanded === "panel9"} />}
          aria-controls="panel9bh-content"
          id="panel9bh-header"
        >
          <Typography style={{ fontSize: "1.2rem" }}>
            Transgenic Technologies
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            Learn about creating transgenic organisms, gene knockout models, chromosomal engineering, gene silencing, and their agricultural and medical uses.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion
        className="py-2"
        expanded={expanded === "panel10"}
        onChange={handleChange("panel10")}
      >
        <AccordionSummary
          expandIcon={<CustomExpandIcon isExpanded={expanded === "panel10"} />}
          aria-controls="panel10bh-content"
          id="panel10bh-header"
        >
          <Typography style={{ fontSize: "1.2rem" }}>
            Plant Genetic Engineering
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            Discover methods used in plant transformation, crop improvement, and genetic modification for sustainable agriculture.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion
        className="py-2"
        expanded={expanded === "panel11"}
        onChange={handleChange("panel11")}
      >
        <AccordionSummary
          expandIcon={<CustomExpandIcon isExpanded={expanded === "panel11"} />}
          aria-controls="panel11bh-content"
          id="panel11bh-header"
        >
          <Typography style={{ fontSize: "1.2rem" }}>
           Genomics & Forensic Applications
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            Understand DNA profiling, genetic defect detection, and the application of genomics in medicine, forensics, and biotechnology.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion
        className="py-2"
        expanded={expanded === "panel12"}
        onChange={handleChange("panel12")}
      >
        <AccordionSummary
          expandIcon={<CustomExpandIcon isExpanded={expanded === "panel12"} />}
          aria-controls="panel12bh-content"
          id="panel12bh-header"
        >
          <Typography style={{ fontSize: "1.2rem" }}>
            Minor & Major Project
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            Apply your learning to hands-on research — from gene cloning and DNA analysis to presenting real-world case studies and lab-based projects.
          </Typography>
        </AccordionDetails>
      </Accordion>
 {!showMore && (
        <div style={{ textAlign: "center", marginTop: "2rem" }}>
          <Button
            variant="outlined"
            color="primary"
            onClick={() => setShowMore(true)}
            style={{
              fontWeight: "600",
              fontSize: "1rem",
              textTransform: "none",
              borderRadius: "8px",
            }}
          >
            + Show More
          </Button>
        </div>
      )}
      {/* ---- Skill Development Section ---- */}
      {showMore && (
        <div style={{ marginTop: "3rem" }}>
          <Typography
            variant="h5"
            style={{
              textAlign: "center",
              marginBottom: "0.5rem",
               fontWeight: "500",
              color: "#2b1c50",              
              fontSize: "2.5rem",
              userSelect: "none",              
            }}
          >
            Skill Development            
          </Typography>         
          <Typography
            variant="body1"
            style={{
              textAlign: "center",
              color: "var(--color-grey-darken-2)",
              fontFamily: "'Poppins', sans-serif",
              fontSize: "0.9rem",
              maxWidth: "1000px",
              margin: "0 auto 2rem", 
              lineHeight: "1.8",
              userSelect: "none",
           }}
           >
          Boost your confidence, build job-ready skills, and get professional exposure with our practical, mentor-led sessions.
          </Typography>
          
          <Accordion expanded={expanded === "skill1"} onChange={handleChange("skill1")}>
            <AccordionSummary
              expandIcon={<CustomExpandIcon isExpanded={expanded === "skill1"} />}
              aria-controls="skill1-content"
              id="skill1-header"
              style={{ minHeight: '70px' }}
            >
              <Typography style={{ fontSize: "1.2rem" }}>
                Learn to Ace Interviews
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
             <Typography>
             Master the art of first impressions! Understand professional dressing, confident body language, and effective communication to impress interviewers in both online and offline settings.           
          </Typography>
            </AccordionDetails>
          </Accordion>
          <Accordion expanded={expanded === "skill2"} onChange={handleChange("skill2")}>
            <AccordionSummary
              expandIcon={<CustomExpandIcon isExpanded={expanded === "skill2"} />}
              aria-controls="skill2-content"
              id="skill2-header"
              style={{ minHeight: '70px' }}
            >
              <Typography style={{ fontSize: "1.2rem" }}>
                Learn to Prepare Professionally
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>
               Get ready like a pro! Know what documents to carry, how to handle online connectivity, and maintain etiquette throughout your interview process.
              </Typography>
            </AccordionDetails>
          </Accordion>
          
          <Accordion expanded={expanded === "skill3"} onChange={handleChange("skill3")}>
            <AccordionSummary
              expandIcon={<CustomExpandIcon isExpanded={expanded === "skill3"} />}
              aria-controls="skill3-content"
              id="skill3-header"
              style={{ minHeight: '70px' }}
            >
              <Typography style={{ fontSize: "1.2rem" }}>
                Learn to Build an ATS-Optimized Resume
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>
               Create a standout resume that passes recruiter screening. Learn about ATS keywords, structure, and impactful statements that highlight your achievements effectively.
              </Typography>
            </AccordionDetails>
          </Accordion>
          <Accordion expanded={expanded === "skill4"} onChange={handleChange("skill4")}>
            <AccordionSummary
              expandIcon={<CustomExpandIcon isExpanded={expanded === "skill4"} />}
              aria-controls="skill4-content"
              id="skill4-header"
              style={{ minHeight: '70px' }}
            >
              <Typography style={{ fontSize: "1.2rem" }}>
                Learn How Recruiters Screen Resumes
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>
                Get insider insights into how HRs and recruiters shortlist candidates. Understand what they look for and tailor your resume for better visibility.
              </Typography>
            </AccordionDetails>
          </Accordion>
          <Accordion expanded={expanded === "skill5"} onChange={handleChange("skill5")}>
            <AccordionSummary
              expandIcon={<CustomExpandIcon isExpanded={expanded === "skill5"} />}
              aria-controls="skill5-content"
              id="skill5-header"
              style={{ minHeight: '70px' }}
            >
              <Typography style={{ fontSize: "1.2rem" }}>
                 Learn LinkedIn Profile Optimization
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>
              Build a powerful LinkedIn profile that attracts recruiters. Learn how to grow your network, attempt skill assessments, and apply for relevant job or internship opportunities.
              </Typography>
            </AccordionDetails>
          </Accordion>
          <Accordion expanded={expanded === "skill6"} onChange={handleChange("skill6")}>
            <AccordionSummary
              expandIcon={<CustomExpandIcon isExpanded={expanded === "skill6"} />}
              aria-controls="skill6-content"
              id="skill6-header"
              style={{ minHeight: '70px' }}
            >
              <Typography style={{ fontSize: "1.2rem" }}>
                 Learn Post-Interview Strategies
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>
                Know what to do after your interview — from handling feedback to understanding different interview types, consultancies, and HR connections for future opportunities.
              </Typography>
            </AccordionDetails>
          </Accordion>
          <Accordion expanded={expanded === "skill7"} onChange={handleChange("skill7")}>
            <AccordionSummary
              expandIcon={<CustomExpandIcon isExpanded={expanded === "skill7"} />}
              aria-controls="skill7-content"
              id="skill7-header"
              style={{ minHeight: '70px' }}
            >
              <Typography style={{ fontSize: "1.2rem" }}>
                Learn Workplace & Office Etiquette
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>
               Step into the corporate world confidently! Learn workplace ethics, POSH guidelines, onboarding checks, and professional behavior to thrive in any environment.
              </Typography>
            </AccordionDetails>
          </Accordion>
          <Accordion expanded={expanded === "skill8"} onChange={handleChange("skill8")}>
            <AccordionSummary
              expandIcon={<CustomExpandIcon isExpanded={expanded === "skill8"} />}
              aria-controls="skill8-content"
              id="skill8-header"
              style={{ minHeight: '70px' }}
            >
              <Typography style={{ fontSize: "1.2rem" }}>
                Learn Effective Communication & Ethics
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>
               Develop soft skills that matter — clear communication, gesture control, and maintaining professionalism in every conversation and meeting.
              </Typography>
            </AccordionDetails>
          </Accordion>
          <Accordion expanded={expanded === "skill9"} onChange={handleChange("skill9")}>
            <AccordionSummary
              expandIcon={<CustomExpandIcon isExpanded={expanded === "skill9"} />}
              aria-controls="skill9-content"
              id="skill9-header"
              style={{ minHeight: '70px' }}
            >
              <Typography style={{ fontSize: "1.2rem" }}>
                Learn Through Real HR Mock Interviews
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>
                Gain hands-on experience with mock interview practice sessions conducted by real Talent Acquisition professionals.
                Get personalized feedback, understand real interview dynamics, and improve your confidence before stepping into actual interviews.
              </Typography>
            </AccordionDetails>
          </Accordion>
        </div>
      )}
    </div>
  );
}


